import { render, staticRenderFns } from "./EditPurchasePage.vue?vue&type=template&id=7960616a&scoped=true&"
import script from "./EditPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./EditPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPurchasePage.vue?vue&type=style&index=0&id=7960616a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960616a",
  null
  
)

export default component.exports